import SHARED from '../../constants';
import FileTypeComponent from '../FileTypeComponent';
import styles from './styles.module.css';
import zip from '../../../../assets/imgs/fileTypes/zip.png';
import rar from '../../../../assets/imgs/fileTypes/rar.png';
import doc from '../../../../assets/imgs/fileTypes/doc.png';
import pdf from '../../../../assets/imgs/fileTypes/pdf.png';
import mp3 from '../../../../assets/imgs/fileTypes/mp3.png';
import mp4 from '../../../../assets/imgs/fileTypes/mp4.png';
import React, { useContext, useEffect, useState } from 'react';
import AudioPlayer from '../AudioPlayer';
import { AdminContext } from '../../context/AdminContext';
import AppIcons from '../../icons';
import CenterModal from '../CenterModal';
import ZoomModalContent from '../ZoomModalContent';
import AudioPlayerUnActive from '../AudioPlayerUnActive';
import FileContent from '../FileContent';
import DateComponent from '../DateComponent';
import MessageDateSeen from '../MessageDateSeeen';
import CreateImageSrc from '../../functions/CreateImageSrc';
import Loader from '../Loader';
import SharedFunc from '../../functions/SharedFunc';

const FileTypesContainer = ({
  item,
  extraStyle,
  chatBody = false,
  activePlayer,
  setActivePlayer,
  activePlayerFunction,
  activeMessage,
  setActiveMessage,
  messages,
  showSeen,
}) => {
  const {
    activeUser,
    activeAudio,
    setActiveAudio,
    setSeekValue,
    setPlaying,
    openZoomModal,
    setOpenZoomModal,
    zoomContent,
    setZoomeContent,
    downloadedFiles,
    setDownloadedFiles,
  } = useContext(AdminContext);

  useEffect(() => {
    if (window.electron) {
      getUpdatedFunction();
    }
  }, []);

  const getUpdatedFunction = () => {
    window.electron.ipcRenderer.once('files', (event) => {
      setDownloadedFiles(event);
    });
    window.electron.ipcRenderer.sendMessage(
      'files',
      []
      // item?.file?.fileExtension?.type
    );
  };

  useEffect(() => {
    if (
      activeMessage != undefined &&
      activeMessage?.length != 0 &&
      activeMessage != null
    ) {
      // document.getElementById(`this${activeMessage}`).play();
    }
  }, [activeMessage]);
  useEffect(() => {}, [downloadedFiles]);
  console.log('item====', item);

  return (
    <>
      <div
        className={`${!chatBody && 'border'} ${
          item?.file?.fileExtension?.type == 'video' ||
          (item?.file?.fileExtension?.type == 'image' && !chatBody)
            ? `${styles.fileSmall} ${
                !chatBody
                  ? `${styles.extraMargin} ${styles.fixedHeightSmall}`
                  : styles.imageRadius
              }`
            : `${styles.file} ${!chatBody && styles.fixedHeight}`
        } ${extraStyle} `}
      >
        <FileTypeComponent
          path={SHARED?.socketServerImage}
          type="image"
          item={item}
          downloadedFiles={downloadedFiles}
          chatBody={chatBody}
          setDownloadedFiles={setDownloadedFiles}
          showName={chatBody ? false : true}
          extraNameStyle={!chatBody && styles.extraNameStyle}
          onClick={() => {
            setOpenZoomModal(true);
            setZoomeContent({ item: item, type: 'image' });
            // setActiveMessage('');
          }}
          extraClassName={
            !chatBody ? styles.imageBack : `${styles.imageNoBack} `
          }
          
        >
          {/* {chatBody ? (
            <div className={`h-full w-auto ${chatBody && 'relative'}`}>
              <img
                src={`${SHARED?.socketServerImage}${item?.file?.name}`}
                id={item?.id}
              />
              {item?.file?.fileExtension?.type == 'image' && chatBody && (
                <MessageDateSeen item={item} showSeen={showSeen} />
              )}
            </div>
          ) : ( */}
          {item?.file?.name?.length==0 
          ? 
          <Loader width={`w-full h-100px ${styles.loader}`} />
          :
          <img
            src={`${SHARED?.socketServerImage}${CreateImageSrc(item?.file?.name)}`}
            id={item?.id}
          />
}
          {/* )} */}
        </FileTypeComponent>

        <FileTypeComponent
          // path={SHARED?.socketServerVideo}
          path={SharedFunc(item?.file?.serverId,'socketServerVideo')}
          type="video"
          item={item}
          downloadedFiles={downloadedFiles}
          chatBody={chatBody}
          setDownloadedFiles={setDownloadedFiles}
          showName={chatBody ? false : true}
          extraNameStyle={!chatBody && styles.extraNameStyle}
          onClick={() => {
            setActiveMessage(item?.id);
            setPlaying(false);

            // setActiveAudio();
            // setSeekValue(0);
            setPlaying(false);
            // setOpenZoomModal(true);
            // setZoomeContent({ item: item, type: 'video' });
          }}
          extraClassName={
            !chatBody ? styles.imageBack : `${styles.imageNoBack} `
          }
          
        >
          <div
            className={`relative h-full w-full flex flex-row justify-center item-center ${
              chatBody ? 'videoBlack' : 'videoBlackFile'
            } `}
            onClick={() => {
              setOpenZoomModal(true);
              setZoomeContent({ item: item, type: 'video' });
              setActiveMessage('');
              // setActiveAudio();
              setPlaying(false);
            }}
          >
            <video src={''} poster={item?.fileImage?.name ? `${SHARED?.IMAGE_URL}${item?.fileImage?.name}` : ''}/>
            {/* <p className={styles.absoluteName}>{item?.file?.name}</p> */}
            <div
              className={`absolute w-full h-full flex justify-center items-center top-0`}
            >
              <AppIcons.PlayIconVideo width={40} height={40} />
            </div>
          </div>
        </FileTypeComponent>

        <FileTypeComponent
          // path={SHARED?.socketServerMusic}
          path={SharedFunc(item?.file?.serverId,'socketServerMusic')}
          type="music"
          item={item}
          downloadedFiles={downloadedFiles}
          chatBody={chatBody}
          setDownloadedFiles={setDownloadedFiles}
          extraClassName={`relative`}
          showName={chatBody ? false : true}
          extraNameStyle={!chatBody && styles.extraNameStyleMusic}
          
        >
          {/* {chatBody ? (
            <> */}
          {item?.id == activeMessage ? (
            <AudioPlayer
              id={`${chatBody ? item?.id : item?.id + 'file'}`}
              src={
                item?.id == activeMessage
                  // ? `${SHARED?.socketServerMusic}${item?.file?.name}`
                  ? `${SharedFunc(item?.file?.serverId,'socketServerMusic')}${item?.file?.name}`
                  : ''
              }
              // onClick={() => {
              //   setActiveMessage(item?.id);
              //   setActiveAudio(item);
              // }}
              setActiveMessage={setActiveMessage}
              activeMessage={activeMessage}
              control={true}
              item={item}
              extraStyle={!chatBody && styles.extraPlayerStyle}
            />
          ) : (
            <AudioPlayerUnActive
              control={false}
              id={item?.id}
              src={''}
              item={item}
              extraStyle={!chatBody && styles.extraPlayerStyle}
            />
          )}
          {/* </>
          ) : (
            <img src={mp3} />
          )} */}
        </FileTypeComponent>

        <FileTypeComponent
          // path={SHARED?.socketServerFile}
          path={SharedFunc(item?.file?.serverId,'socketServerFile')}
          type="zip"
          item={item}
          downloadedFiles={downloadedFiles}
          chatBody={chatBody}
          setDownloadedFiles={setDownloadedFiles}
          extraNameStyle={!chatBody && styles.extraNameStyleFile}
          
        >

          <FileContent item={item} path={SharedFunc(item?.file?.serverId,'socketServerFile')} chatBody={chatBody}/>
          {/* <img src={zip} /> */}
        </FileTypeComponent>

        <FileTypeComponent
          // path={SHARED?.socketServerFile}
          path={SharedFunc(item?.file?.serverId,'socketServerFile')}
          type="rar"
          item={item}
          downloadedFiles={downloadedFiles}
          chatBody={chatBody}
          setDownloadedFiles={setDownloadedFiles}
          extraNameStyle={!chatBody && styles.extraNameStyleFile}
          
        >

          <FileContent item={item} path={SharedFunc(item?.file?.serverId,'socketServerFile')} chatBody={chatBody}/>
    
          {/* <img src={rar} /> */}
        </FileTypeComponent>

        <FileTypeComponent
          // path={SHARED?.socketServerFile}
          path={SharedFunc(item?.file?.serverId,'socketServerFile')}
          type="doc"
          item={item}
          downloadedFiles={downloadedFiles}
          chatBody={chatBody}
          setDownloadedFiles={setDownloadedFiles}
          extraNameStyle={!chatBody && styles.extraNameStyleFile}
          
        >

          <FileContent item={item} path={SharedFunc(item?.file?.serverId,'socketServerFile')} chatBody={chatBody}/>
   
          {/* <img src={doc} /> */}
        </FileTypeComponent>

        <FileTypeComponent
          // path={SHARED?.socketServerFile}
          path={SharedFunc(item?.file?.serverId,'socketServerFile')}
          type="pdf"
          item={item}
          downloadedFiles={downloadedFiles}
          chatBody={chatBody}
          setDownloadedFiles={setDownloadedFiles}
          extraNameStyle={!chatBody && styles.extraNameStyleFile}
          
        >
          {/* <img src={pdf} /> */}

          <FileContent item={item} path={SharedFunc(item?.file?.serverId,'socketServerFile')} chatBody={chatBody}/>
  
        </FileTypeComponent>
      </div>
    </>
  );
};
export default FileTypesContainer;
